export var PaymentType;
(function (PaymentType) {
    PaymentType["card"] = "CARD";
    PaymentType["bill"] = "BILL";
})(PaymentType || (PaymentType = {}));
